import VueRouter from "vue-router";
import MyList from "./pages/Mylist/MyList";

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/my-list/folders/:folderId',
            name: 'my-list-folder',
            component: MyList
        }
    ],
});

export default router;
